import { useState, useEffect } from 'react';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const navItems = [
    { label: '首页', href: '#hero' },
    { label: '移动观影', href: '#app' },
    { label: '观众热评', href: '#comments' },
    { label: '平台优势', href: '#features' },
    { label: '热门话题', href: '#topics' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px] max-w-screen-2xl mx-auto">
          <a
            href="#hero"
            className="flex items-center gap-2 text-xl font-heading text-foreground-950 no-underline whitespace-nowrap"
          >
            <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-sm font-bold">
              木
            </span>
            <span className={scrolled ? 'text-foreground-950' : 'text-white'}>
              木瓜影视
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
            aria-label="菜单"
          >
            <i className={`ri-menu-line text-xl ${scrolled ? 'text-foreground-950' : 'text-white'}`}></i>
          </button>
        </div>
      </div>
    </header>
  );
}